import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../../components/kiene-table/kiene-table.service';
import { Befundmitteilung, BefundmitteilungExtern } from '../../befundmitteilung';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BefundDokumentSortierung } from './externe-befunde-dialog';
import { BefundmitteilungService } from '../../befundmitteilung.service';

@Component({
    selector: 'kiene-externe-befunde-dialog',
    templateUrl: './externe-befunde-dialog.component.html',
    styleUrls: ['./externe-befunde-dialog.component.css'],
})
export class ExterneBefundeDialogComponent {
    befundmitteilung: Befundmitteilung;
    externeBefunde: BefundmitteilungExtern[] = [];
    isSaving = false;

    constructor(
        public dialogRef: MatDialogRef<ExterneBefundeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly pdfViewerService: PdfViewerDesktopService,
        private readonly api: KieneTableService,
        private readonly messageService: MessageService,
        private readonly befundmitteilungService: BefundmitteilungService,
    ) {
        if (this.data) {
            this.befundmitteilung = data.befundmitteilung;
            this.externeBefunde = data.externeBefunde;
        }
    }

    dropPosition(event: CdkDragDrop<BefundmitteilungExtern[]>) {
        if (
            event.previousIndex >= 0 &&
            event.currentIndex >= 0 &&
            event.previousIndex < this.externeBefunde?.length &&
            event.currentIndex < this.externeBefunde?.length
        ) {
            this.isSaving = true;
            const bds = new BefundDokumentSortierung();
            bds.be_id_1 = this.externeBefunde[event.previousIndex].be_id;
            bds.be_id_2 = this.externeBefunde[event.currentIndex].be_id;
            bds.sortierung_1 = event.currentIndex;
            bds.sortierung_2 = event.previousIndex;
            moveItemInArray(this.externeBefunde, event.previousIndex, event.currentIndex);
            this.api.post(this.apiBaseUrl + 'befund_dokument/update.php', bds).subscribe({
                next: () => {
                    this.messageService.infoMessage('Erfolgreich gespeichert!');
                    this.isSaving = false;
                    this.reload();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler!', err);
                    this.isSaving = false;
                    this.reload();
                },
            });
        }
    }

    delete(externerBefund: BefundmitteilungExtern, index: number) {
        if (externerBefund.be_id) {
            this.isSaving = true;
            this.api.post(this.apiBaseUrl + 'befund_dokument/delete.php', externerBefund, null).subscribe(
                () => {
                    this.messageService.infoMessage('Die Datei wurde erfolgreich gelöscht!');
                    this.isSaving = false;
                    this.reload();
                },

                error => {
                    this.messageService.errorMessage('Die Datei konnte nicht gelöscht werden!', error);
                    this.isSaving = false;
                },
            );
        }
    }

    reload() {
        this.befundmitteilungService.getPdfIdsForBefundmitteilung(this.befundmitteilung.befund_id).subscribe({
            next: response => {
                this.externeBefunde = response.records;
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }

    openFile(externerBefund: BefundmitteilungExtern) {
        if (externerBefund.pdf_id) {
            const input = new PdfViewerDialogInput(
                'befund_dokument/read_pdf.php',
                new HttpParams().set('be_id', externerBefund?.be_id?.toString()),
                'Befund Extern',
            );
            this.pdfViewerService.openPdfViewer(input);
        }
    }

    close() {
        this.dialogRef.close();
    }
}
